'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function FontPickerModel(fontFamilies) {
	if (!fontFamilies) {
		throw new Error('invalid-args');
	}
	const self = observable(this),
		textFamilies = fontFamilies && fontFamilies({textFontOnly: true}),
		completePick = function (fontFamilyKey, resolve, reject) {
			self.dispatchEvent('hideFontPicker');
			if (fontFamilyKey !== undefined) {
				resolve(fontFamilyKey);
			} else {
				reject();
			}
		};

	self.getFontFamily = fontFamilyKey => {
		if (!fontFamilyKey) {
			throw new Error('invalid-args');
		}
		return textFamilies[fontFamilyKey];
	};
	self.fontPicked = function () { };
	self.pickFont = () => {
		self.dispatchEvent('showFontPicker');
		return new Promise(function (resolve, reject) {
			self.fontPicked = function (fontFamilyKey) {
				completePick(fontFamilyKey, resolve, reject);
			};
		});

	};
	self.getTextFontFamilyKeys = () => Object.keys(textFamilies);
	self.fontPickCancelled = function () {
		self.fontPicked();
	};
	self.fontPickedDefault = function () {
		self.fontPicked('Sans');
	};

};
